import type { Position } from '../value-objects/Position';
import type { Dimensions } from '../value-objects/Dimensions';
import type { Transform } from '../value-objects/Transform';
import type { CuboidInfo } from '../value-objects/CuboidInfo';

export class Cuboid {
  constructor(
    readonly uuid: string,
    readonly position: Position,
    readonly dimensions: Dimensions,
    readonly transform: Transform,
    readonly info: CuboidInfo,
  ) {}
}
